import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { ACTION_LIST } from "models/role/action";
import { SUBJECT_PAYMENT } from "models/role/subject";
import { lazyRetryWithPreload } from "utils/lazyRetryWithPreload";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const MandatesList = lazyRetryWithPreload(
  () => import("../pages/List"),
  "MandatesList"
);

export const mandatesRoutes: Route = {
  title: [COMMON_TRANSLATION_KEYS.mandates],
  path: PAGE_URLS.list,
  component: MandatesList,
  showChildrenInSidebar: false,
  can: {
    do: ACTION_LIST,
    on: SUBJECT_PAYMENT,
  },
};
